import { createSelector } from "reselect";
import { localStateSelector } from "../../selectors";

export const makePaymentMethodsSelector = () => {
  return createSelector([localStateSelector], (localState) =>
    localState.cart.paymentMethods.filter((x) => {
      if (!localState.cart.dueAmount && x.integratedAppKey === "Flutterwave") return false;

      return true;
    })
  );
};
